// src/pages/OAuthSuccess.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials, getUserByID } from "../features/auth/authSlice";
import { getOrganization } from "../features/organization/orgSlice";
import Loader from "../Components/Loader";

export default function OAuthSuccess() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const token = params.get("token");
    const userId = params.get("id");

    if (!token || !userId) {
      return navigate("/auth/login");
    }
    localStorage.setItem("token", JSON.stringify(token));

    dispatch(getUserByID(userId))
      .unwrap()
      .then((response) => {
        const user = response.user;
        // save into Redux + localStorage
        dispatch(setCredentials({ user, token }));

        // get org
        const orgId = response?.user?.organization?.["$oid"];
        dispatch(getOrganization(orgId));
        navigate("/dashboard/main");
      })
      .catch((error) => {
        console.error(error);
        // on error, send them back to login
        navigate("/auth/login");
      });
  }, [search]);

  return <Loader />;
}
